const learningImages = {
  logoIcon: require(`src/assets/lms/logo-icon.svg`).default,
  sidebar: {},
};

export default learningImages;
